const AppLayout = ({ children }) => <div className="app">{children}</div>;

export default AppLayout;
